// @flow
import * as React from 'react'

import Header from 'components/Header'
import SuccessInfoArea from 'components/SuccessInfoArea'
import withTheme from 'hoc/withTheme'
import supportedThemes from './themes/__supportedThemes'
import HeaderWithVoucher from 'components/HeaderWithVoucher'
import styles from './styles.module.scss'

function SuccessInfo () {
    return (
        <>
            <Header/>

            <div className={styles.layoutWrapper}>
                <div className={styles.layout}>
                    <div className={styles.step}>
                        <div className={styles.formContainer}>
                            <HeaderWithVoucher/>
                            <SuccessInfoArea/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withTheme(supportedThemes)(SuccessInfo)
